export interface IAttachmentState {
  loading: boolean;
  loaded: boolean;
}

export enum EAttachmentsAction {
  SaveRestrictedAccessAttachment = 'saveRestrictedAccessAttachment',
  SaveRecipientAttachment = 'saveRecipientAttachment',
  SaveRecipientAttachmentSuccess = 'saveRecipientAttachmentSuccess',
  SaveRecipientAttachmentFailed = 'saveRecipientAttachmentFailed',
  Reset = 'reset',
}

export enum EAttachmentsMutation {
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetState = 'setState',
}
